import { render } from "./AddTeamView.vue?vue&type=template&id=50036264"
import script from "./AddTeamView.vue?vue&type=script&lang=js"
export * from "./AddTeamView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__